module.exports = function getResource(label, vars = []) {
    const resources = {
        kilometer: 'kilomètre',
        mile: 'mille',
        away: 'absent',
        closed: 'Fermé',
        storeClosed: 'Magasin fermé',
        openUntil: `Ouvert jusqu’à ${vars[0]}`,
        getDirections: 'Obtenir l’itinéraire',
        kohlsCopy: 'Sephora promotions and rewards may not apply at Kohl\'s stores.'
    };

    return resources[label];
};
